import { render, staticRenderFns } from "./ListSubscriptionPage.vue?vue&type=template&id=635bf966"
import script from "./ListSubscriptionPage.vue?vue&type=script&lang=js"
export * from "./ListSubscriptionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports